import React from "react";
import {
  FaInstagram,
  FaLinkedin,
  FaGithub,
  FaWhatsapp,
  FaFreeCodeCamp,
  FaPhone,
  // FaYoutube,
} from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import { animateScroll as scroll } from "react-scroll";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinksItems,
  FooterLinkTitle,
  FooterLink,
  FooterLinkRow,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRight,
  SocialIconsLink,
} from "./FooterElements";

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer id="/footer">
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinksItems>
              <FooterLinkTitle>Frontend</FooterLinkTitle>
              <FooterLink>HTML</FooterLink>
              <FooterLink>CSS</FooterLink>
              <FooterLink>Javascript</FooterLink>
              <FooterLink>React JS</FooterLink>
              <FooterLink>Next JS</FooterLink>
              <FooterLink>Materia UI</FooterLink>
              <FooterLink>Redux</FooterLink>
            </FooterLinksItems>
            <FooterLinksItems>
              <FooterLinkTitle>Backend</FooterLinkTitle>
              <FooterLink>Node JS</FooterLink>
              <FooterLink>Express</FooterLink>
              <FooterLink>Swagger</FooterLink>
            </FooterLinksItems>
            <FooterLinksItems>
              <FooterLinkTitle>Databases</FooterLinkTitle>
              <FooterLink>Postgres SQL</FooterLink>
              <FooterLink>Mongo DB</FooterLink>
              <FooterLink>MySql</FooterLink>
              <FooterLink>Sequelize</FooterLink>
            </FooterLinksItems>
            <FooterLinksItems>
              <FooterLinkTitle>Contáctame</FooterLinkTitle>
              <FooterLinkRow>
                <FaPhone /> +54-3525-619061
              </FooterLinkRow>
              <FooterLinkRow>
                <AiOutlineMail /> jonatan.c.ochoa@gmail.com
              </FooterLinkRow>
              <FooterLinkRow>
                <FaLinkedin /> @jonaochoa
              </FooterLinkRow>
              <FooterLinkRow>
                <FaGithub /> jona-ochoa
              </FooterLinkRow>
               <FooterLinkRow>
                <FaInstagram /> @jonanochoa
              </FooterLinkRow>
            </FooterLinksItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="/" onClick={toggleHome}>
              Jonatan Ochoa
            </SocialLogo>
            <WebsiteRight>
              © {new Date().getFullYear()} Jonatan Ochoa Full Stack Developer
            </WebsiteRight>

            <SocialIconsLink
              href="mailto:jonatan.c.ochoa@gmail.com"
              target="_blank"
              aria-label="Email"
            >
              <AiOutlineMail />
            </SocialIconsLink>

            <SocialIconsLink
              href="https//www.instagram.com/jonanochoa/?hl=es-la"
              target="_blank"
              aria-label="Instagram"
            >
              <FaInstagram />
            </SocialIconsLink>

            <SocialIconsLink
              href="https//github.com/jona-ochoa"
              target="_blank"
              aria-label="GitHub"
            >
              <FaGithub />
            </SocialIconsLink>

            <SocialIconsLink
              href="https//linkedin.com/in/jonaochoa"
              target="_blank"
              aria-label="Linkedin"
            >
              <FaLinkedin />
            </SocialIconsLink>

            <SocialIconsLink
              href="https://wa.me/543525619061?text=Hola%20Jonaochoa"
              target="_blank"
              aria-label="Whatsapp"
            >
              <FaWhatsapp />
            </SocialIconsLink>

            <SocialIconsLink
              href="https://www.freecodecamp.org/certification/jona-ochoa/responsive-web-design"
              target="_blank"
              aria-label="FreeCodeCamp"
            >
              <FaFreeCodeCamp />
            </SocialIconsLink>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
